<template>
  <div class="wlx-tea-apply-manager-wrapper">
    <div class="tea-apply-head" :style="{backgroundImage : 'url('+ (headImg) +')'}">
      <div class="head-user-info">
        <i class="wl-icon-ai207" @click="backToLogin"></i>
        <span class="sp-head-line">|</span>
        <img :src="userInfo.avatar || userAvatar" class="user-avatar-img" />
        <span class="sp-user-name">{{userInfo.userName}}</span>
        <i class="wl-icon-dianyuan" @click="getOutSystem"></i>
      </div>
      <div class="tea-apply-head-title">
        <h1 class="head-title-h1" v-if="certificateId=='dnmeaa2seqbkn9fqiaawfq'">欢迎使用物流管理1+X管理考核站点管理平台!</h1>
        <h1 class="head-title-h1" v-else-if="certificateId=='0j6eacat97rafjaiqtfazg'">欢迎使用供应链运营考核站点管理平台!</h1>
        <h1 class="head-title-h1" v-else>欢迎使用物流管理1+X管理考核站点管理平台!</h1>
        <h2 class="head-title-h2">WELCOME TO USE MANAGERMENT PLATFORM</h2>
      </div>
    </div>
    <div class="tea-apply-content">
      <!-- <div v-if="isExamApply==1" class="site-person-enter-con">
        <span class="site-person-enter-btn" @click="goCerSignatureUpload()">证书签名上传 <i class="wl-icon-youjiantou1"></i> </span> 
      </div> -->
      <div class="tea-apply-main">
        <h3 class="h3-tea-apply-title">已开通权限管理</h3>
        <ul class="clearfix">
          <li class="fl tea-apply-li" @click="enterApplyTest">
            <div class="tea-apply-li-con">
              <p class="p-apply-name">申请记录</p>
            </div>
          </li>

          <li
            class="fl tea-apply-li"
            v-for="(item,index) in openApplyData"
            :key="index"
            :class="{applyState : item.state == 0||item.state == 2}"
            @click="goManager(item.id,item.state,item.name)"
          >
            <div class="tea-apply-li-con">
              <p class="p-apply-name">{{item.name}}</p>
            </div>
            <p class="p-apply-state" v-if="item.state == 0">(审核中)</p>
            <p class="p-apply-state" v-if="item.state == 2">(未通过)</p>
          </li>
        </ul>
        <h3 class="h3-tea-apply-title h3-apply-manager-title">申请管理</h3>
        <div class="clearfix">
          <div
            class="fl apply-post-li"
            @click="trainSiteBtn(index,item.name,item.id)"
            v-for="(item,index) in applyManagerData"
            :key="index"
          >
            <img :src="item.cover" alt />
            <div
              class="tea-apply-con-val post-li-tilte"
              :style="{backgroundColor:item.color}"
              v-if="!item.childData"
            >{{item.name}}</div>
            <el-dropdown
              trigger="click"
              class="tea-apply-con-val post-li-tilte"
              @command="applyTrainSite"
              ref="trainDown"
              v-if="item.childData"
            >
              <span class="el-dropdown-link">{{item.name}}</span>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item
                  v-for="(item,index) in item.childData"
                  :command="item.id"
                  :key="index"
                >{{item.name}}</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </div>
        </div>
      </div>
    </div>
    <footer class="tea-apply-footer">Copyright 版权所有 © 北京中物联物流采购培训中心</footer>
  </div>
</template>

<script>
import { MU_UPATE_AUTH, MU_UPATE_SCHOOL } from "store/index";
import { openSync } from "fs";
export default {
  data() {
    return {
      headImg: require("assets/images/tea-apply-back-img.png"),
      userAvatar: require("assets/images/default_avatar3.png"),
      trainSiteImg: require("assets/images/apply-be-site.png"),
      testSiteImg: require("assets/images/test-site-img.png"),
      applyTeaImg: require("assets/images/apply-to-tea-img.png"),
      evaluteImg: require("assets/images/be-evaluete-img.png"),
      openApplyData: [],
      applyManagerData: [],
      IsLecturer: 0,
      IsAppraiser: 0,
      isExamApply:0
    };
  },
  created() {
    var that = this;
    if (localStorage["userId"] !== undefined) {
      that.$store.dispatch(MU_UPATE_AUTH).then(rt => {});
    }
    that.$store.dispatch(MU_UPATE_SCHOOL, { id: window.location.href });
    // that.getBanner();
    that.getSchoolNewsList();
  },
  computed: {
    userInfo() {
      return this.$store.state.auth;
    }
  },
  props:{
    certificateId:{
      type:String,
      default:""
    }
  },
  methods: {
    trainSiteBtn(index, name, id) {
      if (name == "申请成为讲师") {
        this.$router.push({
          name: "applyTable",
          params: {
            userType: "1",
            certificateId:this.certificateId
          }
        });
      }
      if (name == "申请成为考评员") {
        this.$router.push({
          name: "applyTable",
          params: {
            userType: "2",
            certificateId:this.certificateId
          }
        });
      }
      if (name == "申请考核站点") {
        this.$router.push({
          name: "examCenterTable",
          params:{
            certificateId:this.certificateId
          }
        });
      }
      if (name == "1+X考试申报") {
        this.$router.push({
          name: "examSingUp",
          params:{
            certificateId:this.certificateId
          }
        });
      }
      if (name == "考试申报管理") {
        this.$router.push({
          name: "examDeclare",
          params:{
            certificateId:this.certificateId
          }
        });
      }
    },
    applyTrainSite(command) {
      console.log(command);
    },
    backToLogin() {
      this.$router.push({
        name: "xIndex"
      });
    },
    getOutSystem() {
      var that = this;
      this.$http.post("/api/XOrg/XLogin/outLogin", {}).then(function(rst) {
        if (rst.code > 0) {
          that.$store.commit(MU_UPATE_AUTH, null);
          that.$router.push({ name: "xHome" });
        } else {
          that.$message.warning(rst.msg);
        }
      });
    },
    getSchoolNewsList(page) {
      var that = this;
      this.$http.post("/api/XOrg/TeaAuthority/getAuthority", {
        certificateId:this.certificateId
      }).then(rst => {
        if (rst.code == 1) {
          // 权限管理
          var openApplyData = [];
          rst.passSiteList.forEach(ele => {
            if (ele.type == 1) {
              openApplyData.push({
                id: ele.Id,
                name: ele.major + "培训站点管理",
                state: 1
              });
            } else if (ele.type == 2) {
              openApplyData.push({
                id: ele.Id,
                name: ele.major + "考核站点管理",
                state: 3
              });
            }
          });
          // 申请站点权限
          if (rst.isPeiXunApply == 1) {
            that.applyManagerData.push({
              id: "",
              name: "申请培训站点",
              cover: require("assets/images/test-site-img.png"),
              color: "#0065EF"
            });
          }
          if (rst.isKaoHeApply == 1) {
            that.applyManagerData.push({
              id: "",
              name: "申请考核站点",
              cover: require("assets/images/apply-be-site.png"),
              color: "#D62C23"
            });
          }
          // if (rst.isExamApply == 1) {
          //   that.applyManagerData.push({
          //     id: "",
          //     // name: rst.isExam == 1 ? '考试申报管理':'考试申报',
          //     name: "1+X考试申报",
          //     cover: require("assets/images/apply-be-site.png"),
          //     color: "#D62C23"
          //   });
          //   this.isExamApply = 1;
          // }

          // 讲师
          // if (rst.IsLecturer == 1) {
          //   openApplyData.push({
          //     id: "",
          //     name: "讲师管理",
          //     state: 0
          //   });
          // }else if(rst.IsLecturer == 2){
          //   openApplyData.push({
          //     id: "",
          //     name: "讲师管理",
          //     state: 4
          //   });
          // }else if(rst.IsLecturer == 3){
          //   openApplyData.push({
          //     id: "",
          //     name: "讲师管理",
          //     state: 2
          //   });
          //   that.applyManagerData.push({
          //     id: "",
          //     name: "申请成为讲师",
          //     cover: require("assets/images/apply-to-tea-img.png")
          //   });
          // }else {
          //   that.applyManagerData.push({
          //     id: "",
          //     name: "申请成为讲师",
          //     cover: require("assets/images/apply-to-tea-img.png")
          //   });
          // }
          // 考评员
          if (rst.IsAppraiser == 1) {
            openApplyData.push({
              id: "",
              name: "考评员管理",
              state: 0
            });
          } else if (rst.IsAppraiser == 2) {
            openApplyData.push({
              id: "",
              name: "考评员管理",
              state: 5
            });
          } else if (rst.IsAppraiser == 3) {
            openApplyData.push({
              id: "",
              name: "考评员管理",
              state: 2
            });
            that.applyManagerData.push({
              id: "",
              name: "申请成为考评员",
              cover: require("assets/images/be-evaluete-img.png")
            });
          } else {
            that.applyManagerData.push({
              id: "",
              name: "申请成为考评员",
              cover: require("assets/images/be-evaluete-img.png")
            });
          }
          rst.noPassSiteList.forEach(ele => {
            openApplyData.push({
              id: ele.Id,
              name: "考核站点管理",
              state: ele.IsPost
            });
          });
          that.openApplyData = openApplyData;
          that.IsLecturer = rst.IsLecturer;
          that.IsAppraiser = rst.IsAppraiser;
        }
      });
    },
    enterBasicManager() {
      this.$router.push({
        name: "teaBasicInfo"
      });
    },
    enterApplyTest() {
      this.$router.push({
        name: "teaPilotManager"
      });
    },
    goManager(id, state, name) {
      if (name == "考核站点管理") {
        this.$router.push({
          name: "assessmentApplyTea"
        });
      } else if (name == "讲师管理" || name == "考评员管理") {
        this.$router.push({
          name: "TrainApplyManager"
        });
      }

      if (state == 1) {
        // this.$router.push({
        //   name: 'siteHome',
        //   params:{
        //     state: state,
        //     schoolManagerId:id
        //   }
        // })
      } else if (state == 3) {
        // this.$router.push({
        //   name: 'siteHome',
        //   params:{
        //     state:state,
        //     schoolManagerId:id
        //   }
        // })
      }
    },
    goCerSignatureUpload(){
      // this.$router.push({
      //   name: "cerSignatureUpload"
      // });
    }
  }
};
</script>

<style>
</style>
